function postMessage(message) {
  window.parent.postMessage(message, '*');
}

function receiveActions(actions) {
  window.addEventListener('message', async (e) => {
    try {
      if (e.origin !== document.location.ancestorOrigins[0]) return;
      const name = e?.data?.name;
      const payload = e?.data?.payload;
      const callback = e?.data?.callback;
      if (!name) return;
      if (typeof actions[name] !== 'function') {
        throw new Error(`"${name}" is not function please check your function call`);
      }
      const result = await actions[name](payload);
      if (typeof callback === 'string') {
        postMessage({ name: callback, payload: result });
      }
    } catch (error) {
      postMessage({ name: 'error', payload: error?.message });
    }
  });
}

function publishEvents(events) {
  for (const name in events) {
    events[name] = (payload) => postMessage({ name, payload });
  }
}

let connected = false;
export function sdkConnector(params) {
  if (connected) return;
  if (typeof params?.actions === 'object') {
    receiveActions(params.actions);
  }
  if (typeof params?.events === 'object') {
    publishEvents(params.events);
  }
  connected = true;
  postMessage({ name: 'ready' });
}
